import * as React from "react";
import { cn } from "../cn";

export interface ChartCardProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Optional right-aligned slot (e.g. a legend hint or value badge). */
  action?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}

/**
 * Shared shell for every chart on the admin dashboard: paper card, rounded
 * border, title + optional subtitle, and an actions slot. Keeps chart blocks
 * visually identical to the rest of the admin surface.
 */
export function ChartCard({
  title,
  subtitle,
  action,
  className,
  children,
}: ChartCardProps) {
  return (
    <section
      className={cn(
        "flex flex-col rounded-2xl border border-smoke bg-paper p-4",
        className,
      )}
    >
      <div className="mb-3 flex items-start justify-between gap-2">
        <div className="min-w-0">
          <h3 className="text-sm font-bold text-ink">{title}</h3>
          {subtitle ? (
            <p className="mt-0.5 text-[11px] text-ash">{subtitle}</p>
          ) : null}
        </div>
        {action ? <div className="shrink-0">{action}</div> : null}
      </div>
      {/* grow so empty states can center vertically in an h-full card */}
      <div className="flex flex-1 flex-col justify-center">{children}</div>
    </section>
  );
}
